const ProcessStepData01 = [
    {
        image: "/Images/badge.png",
        title: "SEARCH BY CERTIFICATION LEVEL",
        content: "Identify NPOs vetted for credibility and transparency",
        reRender: 'trustAndTransparency'
    },
    {
        image: "/Images/locationEdited.png",
        imageHover: "/Images/locationEdited.png",
        title: "SEARCH BY GEOGRAPHY",
        content: "Locate NPOs in every state and district across India. You can also search by pincode",
        reRender: 'geography'
    },
    {
        image: "/Images/social-justiceEdited.png",
        title: "SEARCH BY CAUSE",
        content: "Find NPOs for every cause and community you care about",
        reRender: 'cause'
    },
    {
        image: "/Images/count1Edited.png",
        title: "SEARCH BY FINANCIALS",
        content: "Explore NPOs based on their size, tax benefits, and FCRA eligibility",
        reRender: 'financials'
    },
]

const ProcessStepData02 = [
    {
        title: "Project research",
        content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
    },
    {
        title: "Sketches and design",
        content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
    },
    {
        title: "Seleted concept",
        content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
    }
]

const ProcessStepData03 = [
    {
        title: "RESEARCH",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "SKETCHES",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "CONCEPT",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "PRESENTATION",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
]

const ProcessStepData04 = [
    {
        title: "RESEARCH PROJECT",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "FIND PROBLEM",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "START OPTIMIZE",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "REACH TARGET",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
]

const ProcessStepData05 = [
    {
        title: "Start market research",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    },
    {
        title: "Discussion of the idea",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    },
    {
        title: "Production planning",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    }
]

const ProcessStepData06 = [
    {
        title: "Innovative business",
        content: "Easy to customize",
    },
    {
        title: "Expertly marketing",
        content: "High quality services",
    },
    {
        title: "Engaging audiences",
        content: "Build perfect websites",
    }
]


export { ProcessStepData01, ProcessStepData02, ProcessStepData03, ProcessStepData04, ProcessStepData05, ProcessStepData06 }